import React from 'react';

// Import team member images
import erickImage from '../assets/team/erick-okioma.webp';
import humphreyImage from '../assets/team/humphrey-nyakundi.webp';

interface TeamMember {
  id: number;
  name: string;
  role: string;
  expertise: string[];
  image: string;
  social?: {
    linkedin?: string;
    instagram?: string;
  };
}

const Team: React.FC = () => {
  const teamMembers: TeamMember[] = [
    {
      id: 1,
      name: 'Erick Okioma',
      role: 'Lead Engineer & Technical Architect',
      expertise: [
        'Full-Stack Development',
        'Cloud Architecture',
        'Technical Leadership',
        'Network Solutions',
        'System Design'
      ],
      image: erickImage,
      social: {
        linkedin: 'https://www.linkedin.com/in/okiomaerick',
        instagram: 'https://www.instagram.com/okioma_erick'
      },

    },
    {
      id: 2,
      name: 'Humphrey Nyakundi',
      role: 'Head of Strategy & Operations',
      expertise: [
        'Business Strategy',
        'Operations Management',
        'Customer Success',
        'Backend Development',
        'System Architecture'
      ],
      image: humphreyImage,
      social: {
        linkedin: 'https://www.linkedin.com/in/humphrey-nyakundi',
        instagram: 'https://www.instagram.com/its_obaras_fav'
      },

    }
  ];

  return (
    <section id="team" className="team">
      <div className="container">
        <div className="section-header">
          <h2>Our Team</h2>
          <p className="section-subtitle">Meet the brilliant minds behind BorangiLABS</p>
        </div>
        
        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className="team-card">
              <div className="team-card-inner">
                <div className="team-image-container">
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className={`team-image ${member.name.toLowerCase().includes('humphrey') ? 'humphrey-image' : ''}`} 
                  />
                </div>
                <div className="team-content">
                  <h3>{member.name}</h3>
                  <p className="team-role">{member.role}</p>
                  <div className="team-expertise">
                    {member.expertise.map((skill, index) => (
                      <span key={index} className="expertise-tag">{skill}</span>
                    ))}
                  </div>
                  {member.social && (
                    <div className="team-social-links">
                      {member.social.linkedin && (
                        <a 
                          href={member.social.linkedin} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="social-icon linkedin"
                          aria-label={`${member.name} on LinkedIn`}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                          </svg>
                        </a>
                      )}
                      {member.social.instagram && (
                        <a 
                          href={member.social.instagram} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="social-icon instagram"
                          aria-label={`${member.name} on Instagram`}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.987 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 11-2.881.001 1.44 1.44 0 012.881-.001z"/>
                          </svg>
                        </a>
                      )}
                    </div>
                  )}

                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
